import { toArabicIndicDigitsInString } from "src/utils/numberFormat";

/** Shared with SCSS (`.dashboard-date-dropdown .ant-picker-panel-container`). */
export const DASHBOARD_PICKER_PANEL_CLASS = "dashboard-date-dropdown";

const LATIN_DIGIT = /[0-9]/;

/** Ensures the dashboard popup class is present so panel digit conversion can find the portal root. */
export function mergeDashboardPickerPopupClass(popupClassName?: string): string {
  const parts = new Set<string>([DASHBOARD_PICKER_PANEL_CLASS]);
  popupClassName
    ?.trim()
    .split(/\s+/)
    .filter(Boolean)
    .forEach(c => parts.add(c));
  return Array.from(parts).join(" ");
}

const popupRootSelector = (): string =>
  `.${CSS.escape(DASHBOARD_PICKER_PANEL_CLASS)}`;

/**
 * Replaces ASCII digits in all text nodes under an Ant Design picker panel with Eastern Arabic-Indic (٠–٩).
 * Cheap bail-out when the subtree no longer contains Latin digits.
 */
export function convertLatinDigitsInPickerPanel(root: HTMLElement): void {
  if (!LATIN_DIGIT.test(root.textContent ?? "")) {
    return;
  }

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const updates: { node: Text; next: string }[] = [];
  let node: Node | null;
  while ((node = walker.nextNode())) {
    const textNode = node as Text;
    const val = textNode.nodeValue;
    if (val && LATIN_DIGIT.test(val)) {
      const next = toArabicIndicDigitsInString(val);
      if (next !== val) {
        updates.push({ node: textNode, next });
      }
    }
  }

  for (const { node, next } of updates) {
    node.nodeValue = next;
  }
}

export function queryDashboardPickerPanelRoots(): HTMLElement[] {
  return Array.from(document.querySelectorAll(popupRootSelector())).filter(
    (n): n is HTMLElement => n instanceof HTMLElement
  );
}
